<template lang="html">
	<div id="app" class="main column">
		<my-header :menu="menu" @notif-open="notifPanelActive = true"></my-header>
		<div class="page column">
			<router-view></router-view>
		</div>
		<my-footer />
		<notification-panel />
	</div>
</template>

<script>
	import myHeader from '@/common/components/header.vue'
	import NotificationPanel from '@/common/components/notification-panel'
	import myFooter from '@/common/components/footer.vue'

	export default {
		name: 'Hello',
		components: {
			myHeader,
			NotificationPanel,
			myFooter
		},
		data () {
			return {
				notifPanelActive: false,
				menu: [
					{
						key: 0,
						name: '<span class="icon-nav-admin-stat"></span> Accueil',
						uri: 'Home'
					},
					{
						key: 1,
						name: '<span class="icon-nav-operation"></span> Opérations',
						uri: 'Transactions'
					},
					{
						key: 2,
						name: '<span class="icon-nav-actu"></span> Actualités',
						uri: 'Actualities'
					}
				]
			}
		}
	}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Main.vue?5cbd6e31